(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/theme-helpers/assets/javascripts/get-difference.js') >= 0) return;  svs.modules.push('/components/themes/theme-helpers/assets/javascripts/get-difference.js'); "use strict";

(function (svs) {
  var timeUnits = {
    hours: 1000 * 60 * 60,
    minutes: 1000 * 60,
    seconds: 1000,
    milliseconds: 1
  };
  var supportedTimeUnits = Object.keys(timeUnits);

  var getDifferenceBetweenDates = function getDifferenceBetweenDates(date1, date2) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'milliseconds';
    var round = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    if (!~supportedTimeUnits.indexOf(unit)) {
      throw new Error("Unsupported time unit: ".concat(unit, ". Use one of ").concat(supportedTimeUnits.join(', ')));
    }

    var diff = (new Date(date1).getTime() - new Date(date2).getTime()) / timeUnits[unit];
    var roundFn = diff < 0 ? 'ceil' : 'floor';
    return round ? Math[roundFn](diff) : diff;
  };

  svs.themes.getDifferenceBetweenDates = getDifferenceBetweenDates;
})(svs);
 })(window);